module.exports = __webpack_public_path__ + "img/6.704f78c7.jpg";